import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import Navigation from '../../../components/common/Navigation';
import { useHomeBootstrap } from '../hooks/useHomeBootstrap';
const HomeLayout = ({ children }) => {
    const { user, groups } = useHomeBootstrap();
    const sudoOriginalUser = window.__SUDO_ORIGINAL_USER__ || window.CFN?.sudoOriginalUser || null;
    const navUser = useMemo(() => {
        if (!user || !user.email)
            return null;
        return {
            ...user,
            email: user.email, // Ensure email is not null
            Groups: groups.map(group => ({ name: group }))
        };
    }, [user, groups]);
    return (_jsxs("div", { className: "home-shell", children: [navUser && (_jsx(Navigation, { user: navUser, groups: groups, sudoOriginalUser: sudoOriginalUser })), _jsx("main", { className: "home-shell__main", children: children })] }));
};
export default HomeLayout;
